import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  margin-top: 148px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-bottom: 48px;
  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    vertical-align: middle;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: center;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
`

export const ImgCol = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  @media (max-width: 900px) {
    flex: none;
    min-width: unset;
    width: 100%;
    margin-bottom: 0;
  }
`

export const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(217, 217, 217, 0.2);
  box-shadow: 0px 0px 20.68px 3.1px #d9d9d9;
  border-radius: 50px;
  pointer-events: none;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
`
export const StaticContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 32px;
  z-index: 2;
  pointer-events: none;
  transition: opacity 0.3s ease;
`

export const StaticTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  color: #21105d;
  margin: 0;
`

export const StaticSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #21105d;
  margin: 15px 0 0 0;
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 603px;
  cursor: pointer;

  &:hover ${ImageOverlay} {
    opacity: 1;
  }

  &:hover ${StaticContent} {
    opacity: 0;
  }
`

export const OverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  margin-left: 32px;
  gap: 40px;

  @media (max-width: 600px) {
    gap: 20px;
  }
`

export const OverlayTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  color: #21105d;
  margin: 0;
  text-align: left;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`

export const OverlayList = styled.ul`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18.62px;
  line-height: 24.83px;
  color: #21105d;
  margin: 0;
  padding-left: 20px;
  text-align: left;

  @media (max-width: 600px) {
    font-size: 12.62px;
  }

  li {
    color: #21105d;
    &::marker {
      color: #21105d;
    }
  }
`

export const OverlayButton = styled.button`
  width: 200px;
  height: 57px;
  border-radius: 51.72px;
  padding: 16.55px;
  background: #5039dd;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10.34px;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  pointer-events: auto; /* Ensure button is clickable even if overlay wrapper has pointer-events: none */
  transition: opacity 0.2s;

  @media (max-width: 600px) {
    width: 118px;
    height: 35px;
    padding: 8.55px;
    gap: 5.34px;
    font-size: 11px;
  }

  &:hover {
    opacity: 0.9;
  }
`
